import axios from "axios";
import axiosInstance from "../../translator";
import { resourceManagerAPI as resourceManager } from "../../constants/apis/apiEndpoints";
import { localStorageHelper } from "../../utils/storageHelper";
import { translator } from "../../constants/actionTypes";
import { customCloudProviderHeader } from "../../constants/componentConstants";

export const fetchResourceProviderList = async (urlParams) => {
  return axiosInstance
    .get(`${resourceManager?.resourceProvider}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const deleteResourceProvider = async (resource_id) => {
  return axiosInstance
    .delete(`${resourceManager?.resourceProvider}/${resource_id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createTemplateApi = async (urlParams) => {
  return axiosInstance
    .post(resourceManager?.templateEndpoint, urlParams)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const editTemplateApi = async (urlParams) => {
  return axiosInstance
    .put(
      `${resourceManager?.templateEndpoint}/${urlParams.templateId}`,
      urlParams
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchCategory = async (params) => {
  return axiosInstance
    .get(`${resourceManager?.category}${params}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchInstanceWithPagination = async (params) => {
  return axiosInstance
    .get(`${resourceManager?.instancePagination}${params}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const setInstanceSize = async (data) => {
  return axiosInstance
    .post(`${resourceManager?.instancePagination}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const deleteInstanceSize = async ({ params, id }) => {
  return axiosInstance
    .delete(`${resourceManager?.instancePagination}/${id}${params}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchInstances = async () => {
  return axiosInstance
    .get(`${resourceManager?.instances}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getVmSnapshot = async (urlParams) => {
  return axiosInstance
    .get(`${resourceManager?.getVmSnapshot}/${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchTemplateList = async (urlParams) => {
  return axiosInstance
    .get(`${resourceManager?.templates}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const addResourceConnection = async (data) => {
  return axiosInstance
    .post(`${resourceManager?.resourceProvider}/connect/`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const addResourceAccount = async (data) => {
  return axiosInstance
    .post(`${resourceManager?.resourceProvider}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const editResourceAccount = async ({ data, id }) => {
  return axiosInstance
    .put(`${resourceManager?.resourceProvider}/${id}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const deleteTemplate = async (urlParams) => {
  return axiosInstance
    .delete(`${resourceManager?.templates}/${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const uploadTemplateLogo = async (data) => {
  //axios object is used for file upload as contentType is form/data
  return axios
    .post(`${translator.baseURL}/${resourceManager?.uploadLogo}`, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        tenant: localStorageHelper.get("tenantId"),
        accessToken: `Bearer ${localStorageHelper.get("accessToken")}`,
        Authorization: `${localStorageHelper.get("authToken")}`,
        role: localStorageHelper.get("role"),
        authtype: localStorageHelper.get("auth_type"),
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const publishTemplate = async ({ data, id }) => {
  return axiosInstance
    .put(`${resourceManager?.publishTemplate}${id}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
export const publishPooledTemplate = async ({ data, id }) => {
  return axiosInstance
    .put(`${resourceManager?.publishPooledTemplate}${id}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const toggleVtEnabled = async (payload) => {
  return axiosInstance
    .patch(`${resourceManager?.templates}/${payload?.id}`, payload?.data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchResourceProviderDetails = async (id) => {
  return axiosInstance
    .get(`${resourceManager?.resourceProvider}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const templateExportApi = async (data) => {
  return axiosInstance
    .post(`${resourceManager?.exportTemplate}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const recoverTemplateApi = async (urlParams) => {
  return axiosInstance
    .put(
      `${resourceManager?.templateEndpoint}${resourceManager?.recoverTemplate}/${urlParams}`,
      urlParams
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createPublicCloudProvider = async (data) => {
  return axios
    .post(
      `${translator.baseURL}${resourceManager?.cloudProvider}`,
      data,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};
export const updatePublicCloudProvider = async (params) => {
  return axios
    .put(
      `${translator.baseURL}${resourceManager?.cloudProvider}/${params?.id}`,
      params?.payload,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const patchPublicCloudProvider = async (params) => {
  return axios
    .patch(
      `${translator.baseURL}${resourceManager?.cloudProvider}/${params?.id}`,
      params?.payload,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const deletePublicCloudProvider = async (params) => {
  return axios
    .delete(
      `${translator.baseURL}${resourceManager?.cloudProvider}/${params}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const getPublicCloudProviderListRequest = async (urlParams) => {
  return axios
    .get(
      `${translator.baseURL}${resourceManager?.cloudProvider}${urlParams}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};
export const listPublicCloudTemplates = async (urlParams) => {
  return axios
    .get(
      `${translator.baseURL}${resourceManager?.cloudTemplate}${urlParams}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const retrieveCloudProvider = async (urlParams) => {
  return axios
    .get(
      `${translator.baseURL}${resourceManager?.cloudProvider}/${urlParams}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const deletePublicCloudTemplateRequest = async (urlParams) => {
  return axios
    .delete(
      `${translator.baseURL}${resourceManager?.cloudTemplate}/${urlParams}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const createPublicCloudTemplateRequest = async (data) => {
  return axios
    .post(
      `${translator.baseURL}${resourceManager?.cloudTemplate}`,
      data,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const updatePublicCloudTemplateRequest = async (params) => {
  return axios
    .put(
      `${translator.baseURL}${resourceManager?.cloudTemplate}/${params?.id}`,
      params?.payload,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};
export const retrievePublicCloudTemplateRequest = async (id) => {
  return axios
    .get(
      `${translator.baseURL}${resourceManager?.cloudTemplate}/${id}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const patchPublicCloudTemplateRequest = async (params) => {
  return axios
    .patch(
      `${translator.baseURL}${resourceManager?.cloudTemplate}/${params?.id}`,
      params?.payload,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const cloudProviderConnectRequest = async (data) => {
  return axios
    .post(
      `${translator.baseURL}${resourceManager?.cloudConnect}`,
      data,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response?.data;
    });
};

export const fetchAccountDetailsListAPI = async (params) => {
  return axiosInstance
    .get(`${resourceManager?.accountDetailsAPI}${params}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchCleaningNukeJobsAPI = async (params) => {
  return axiosInstance
    .get(`${resourceManager?.cleaningJobsAPI}${params}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchAWSUsageAPI = async (params) => {
  return axiosInstance
    .get(`${resourceManager?.AwsUsageAPI}${params}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchMaintenanceSessionAPI = async (params) => {
  return axiosInstance
    .get(`${resourceManager?.MaintenanceSessionAPI}/${params?.aws_account}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const MarkAsCleanAPI = async (params) => {
  return axiosInstance
    .put(
      `${resourceManager?.MarkAsCleanAPI}/${params?.params?.id}`,
      params?.requestPayload
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
